import { DONE, FAILED, REQUEST_LINK, RESET, SENDING } from './constants';

/** Asks for a reset link to be emailed to `email`. */
export const requestLink = (email) => ({ type: REQUEST_LINK, payload: { email } });

/** Sets a new password with the token from the emailed link. */
export const resetPassword = (token, email, password, confirmation) => ({
  type: RESET,
  payload: { token, email, password, password_confirmation: confirmation },
});

export const sending = () => ({ type: SENDING });
/** The server's answer, to show: "If that address has an account…", "Your password is changed…". */
export const done = (message) => ({ type: DONE, payload: { message } });
export const failed = (error) => ({ type: FAILED, payload: { error } });
